/**
 * Created by zad on 17/4/25.
 */
import { Notes } from '../constants/actionTypes';
import createAction from '../utils/createAction';

// 获取文章列表
export const getNotes = createAction(Notes.GET_NOTES, 'nbId', 'isForce', 'page', 'count', 'nid');

// 排序文章
export const sortNotes = createAction(Notes.SORT_NOTES, 'oldSeq', 'newSeq', 'nbId');

// 新建文章
export const newNote = createAction(Notes.NEW_NOTE, 'nbId', 'title', 'atBottom', 'hasTop');

// 将文章转为公开
export const publishNote = createAction(Notes.PUBLISH_NOTE, 'noteId', 'forcedPublish');

// 发布文章，更新文章
export const updateNote = createAction(Notes.UPDATE_NOTE, 'noteId', 'title', 'content');

// 私密文章
export const privateNote = createAction(Notes.PRIVATE_NOTE, 'noteId');

// 移动文章到回收站
export const deleteNoteSoft = createAction(Notes.DEL_NOTE_SOFT, 'nbId', 'noteId', 'doneCallback');

// 移动文章
export const moveNote = createAction(Notes.MOVE_NOTE, 'nbId', 'newNbId', 'noteId', 'doneCallback');

// 发布付费文章
export const publishPaidNote = createAction(Notes.PUBLISH_PAID_NOTE, 'nbId', 'noteId', 'amount', 'content', 'license', 'audioPaid');

// 获取自定义封面
export const getCoverImg = createAction(Notes.GET_COVER_IMG, 'noteId');

// 上传自定义封面
export const postCoverImg = createAction(Notes.POST_COVER_IMG, 'noteId', 'flowType', 'coverImgUrls', 'abbr');

// 置顶文章
export const postSetNoteTop = createAction(Notes.POST_SET_NOTE_TOP, 'noteId');

// 取消置顶文章
export const postUnsetNoteTop = createAction(Notes.POST_UNSET_NOTE_TOP, 'noteId');

export const setNoteReprintAble = createAction(Notes.SET_NOTE_REPRINTABLE, 'noteId');

export const setNotePublishTimeAction = createAction(Notes.SET_NOTE_PUBLISH_TIME, 'noteId', 'publishTime');



// WEBPACK FOOTER //
// ./src/actions/NotesAction.js